export default {
  getSubcategories: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/getters.js